'use client';
import React from 'react';
import Link from 'next/link';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { useLanguage } from '@/lib/LanguageContext';
import { getTranslations } from '@/lib/i18n';

// metadata removed - client component

const results = [
  { value: '40%', labelEs: 'Reducción de tiempos de inactividad', labelFr: 'Réduction des temps d\'arrêt' },
  { value: '+60', labelEs: 'Equipos conectados en red', labelFr: 'Équipements connectés en réseau' },
  { value: '99.8%', labelEs: 'Disponibilidad de servicios', labelFr: 'Disponibilité des services' },
  { value: '3x', labelEs: 'Mejora en velocidad de red', labelFr: 'Amélioration de la vitesse réseau' },
];


const sectors = [
  { icon: 'fas fa-industry', labelEs: 'Industria', labelFr: 'Industrie' },
  { icon: 'fas fa-building', labelEs: 'Corporativo', labelFr: 'Entreprise' },
  { icon: 'fas fa-university', labelEs: 'Educación', labelFr: 'Éducation' },
  { icon: 'fas fa-hospital', labelEs: 'Salud', labelFr: 'Santé' },
  { icon: 'fas fa-building', labelEs: 'Gobierno', labelFr: 'Gouvernement' },
];


const capabilities = [
  { icon: 'fas fa-network-wired', titleEs: 'Diseño de Redes', titleFr: 'Conception de Réseaux', descriptionEs: 'Arquitectura de redes LAN/WAN escalables con segmentación VLAN, redundancia y alta disponibilidad para entornos empresariales exigentes.', descriptionFr: 'Architecture de réseaux LAN/WAN évolutifs avec segmentation VLAN, redondance et haute disponibilité pour les environnements d\'entreprise exigeants.' },
  { icon: 'fas fa-server', titleEs: 'Virtualización de Servidores', titleFr: 'Virtualisation de Serveurs', descriptionEs: 'Implementación de plataformas VMware y Hyper-V para consolidar cargas de trabajo, reducir costos y mejorar la resiliencia operativa.', descriptionFr: 'Déploiement de plateformes VMware et Hyper-V pour consolider les charges de travail, réduire les coûts et améliorer la résilience opérationnelle.' },
  { icon: 'fas fa-cloud', titleEs: 'Migración a la Nube', titleFr: 'Migration vers le Cloud', descriptionEs: 'Estrategias de migración híbrida y multi-cloud que preservan la continuidad del negocio mientras se optimizan costos de infraestructura.', descriptionFr: 'Stratégies de migration hybride et multi-cloud qui préservent la continuité des activités tout en optimisant les coûts d\'infrastructure.' },
  { icon: 'fas fa-shield-alt', titleEs: 'Seguridad Perimetral', titleFr: 'Sécurité Périmétrique', descriptionEs: 'Firewalls de nueva generación, IDS/IPS y segmentación de red para proteger activos críticos frente a amenazas internas y externas.', descriptionFr: 'Pare-feux de nouvelle génération, IDS/IPS et segmentation réseau pour protéger les actifs critiques contre les menaces internes et externes.' },
  { icon: 'fas fa-database', titleEs: 'Almacenamiento y Backup', titleFr: 'Stockage et Sauvegarde', descriptionEs: 'Soluciones SAN/NAS con políticas de respaldo automatizadas, recuperación ante desastres y cumplimiento de RPO/RTO definidos.', descriptionFr: 'Solutions SAN/NAS avec des politiques de sauvegarde automatisées, reprise après sinistre et respect des RPO/RTO définis.' },
  { icon: 'fas fa-chart-bar', titleEs: 'Monitoreo Continuo', titleFr: 'Surveillance Continue', descriptionEs: 'Plataformas de observabilidad 24/7 con alertas proactivas, dashboards en tiempo real y reportes de rendimiento para decisiones informadas.', descriptionFr: 'Plateformes d\'observabilité 24/7 avec alertes proactives, tableaux de bord en temps réel et rapports de performance pour des décisions éclairées.' },
];


export default function PortfolioInfraestructuraPage() {
  const { language } = useLanguage();
  const t = getTranslations(language);
  const p = t.portfolio;
  const isFr = language === 'fr';

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Nunito Sans', 'Raleway', arial, sans-serif" }}>
      <Navbar />
      {/* Hero */}
      <section
        className="relative overflow-hidden"
        style={{ paddingTop: '160px', paddingBottom: '80px', backgroundColor: '#0a0a0a' }}>
        
        <div className="absolute top-20 right-10 opacity-20 hidden lg:block">
          <img src="https://innobox.cl/wp-content/uploads/2021/07/Dots-4.svg" alt="" className="w-40 h-40" />
        </div>
        <div className="absolute bottom-0 left-0 opacity-10 hidden lg:block">
          <img src="https://innobox.cl/wp-content/uploads/2021/07/Abstract-Circle.svg" alt="" className="w-64 h-64" />
        </div>

        <div className="max-w-[1200px] mx-auto px-[35px] relative z-10">
          <nav className="mb-8 flex items-center gap-2 text-sm" style={{ color: '#888' }}>
            <Link href="/" className="hover:text-[#1AEF0F] transition-colors">Inicio</Link>
            <span>/</span>
            <Link href="/#portfolio" className="hover:text-[#1AEF0F] transition-colors">Portfolio</Link>
            <span>/</span>
            <span style={{ color: '#1AEF0F' }}>{isFr ? 'Infrastructure et Réseaux' : 'Infraestructura y Redes'}</span>
          </nav>

          <div className="flex flex-col lg:flex-row items-start gap-12">
            <div className="flex-1">
              <div
                className="inline-flex items-center gap-2 mb-6 px-4 py-2"
                style={{ border: '1px solid #1AEF0F', color: '#1AEF0F', fontSize: '13px', letterSpacing: '2px' }}>
                
                <i className="fas fa-network-wired" />
                <span>{isFr ? 'CAS D\'ÉTUDE' : 'CASO DE ESTUDIO'}</span>
              </div>
              <h1
                className="text-white font-bold mb-6"
                style={{
                  fontSize: 'clamp(32px, 4vw, 56px)',
                  fontFamily: "'Titillium Web', sans-serif",
                  lineHeight: '1.15'
                }}>
                
                {isFr ? 'Infrastructure' : 'Infraestructura'}<br />
                <span style={{ color: '#1AEF0F' }}>{isFr ? 'et Réseaux de Données' : 'y Redes de Datos'}</span>
              </h1>
              <p className="mb-8" style={{ fontSize: '18px', color: '#aaa', lineHeight: '1.7', maxWidth: '560px' }}>
                {isFr ? 'Modernisation complète de l\'infrastructure réseau d\'une organisation industrielle, atteignant 99,8% de disponibilité et une réduction de 40% des temps d\'arrêt.' : 'Modernización completa de la infraestructura de red de una organización industrial, logrando 99.8% de disponibilidad y reducción del 40% en tiempos de inactividad.'}
              </p>
              <div className="flex flex-wrap gap-4">
                <a
                  href="https://calendar.app.google/qrMMuz1WHJJ4eoab8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group relative inline-flex items-center overflow-hidden"
                  style={{
                    border: '1px solid #1AEF0F',
                    padding: '14px 32px',
                    fontSize: '15px',
                    fontWeight: 'bold',
                    color: '#1AEF0F',
                    backgroundColor: 'transparent',
                    transition: 'all 300ms ease-out'
                  }}>
                  
                  <span className="relative z-10 transition-colors duration-300 group-hover:text-black">
                    {isFr ? 'Projet Similaire' : 'Proyecto Similar'}
                  </span>
                  <span
                    className="absolute inset-0 transform translate-x-full group-hover:translate-x-0 transition-transform duration-300"
                    style={{ backgroundColor: '#1AEF0F', zIndex: 0 }} />
                  
                </a>
                <Link
                  href="/#portfolio"
                  className="inline-flex items-center gap-2 text-white hover:text-[#1AEF0F] transition-colors"
                  style={{ fontSize: '15px', padding: '14px 0' }}>
                  
                  <i className="fas fa-arrow-left text-sm" />
                  {isFr ? 'Voir tout le portfolio' : 'Ver todo el portfolio'}
                </Link>
              </div>
            </div>

            {/* Stats */}
            <div className="lg:w-72 grid grid-cols-2 gap-4">
              {results?.map((stat, i) =>
              <div key={i} className="p-5" style={{ border: '1px solid #222', backgroundColor: '#111' }}>
                  <div className="font-bold mb-1" style={{ fontSize: '28px', color: '#1AEF0F', fontFamily: "'Titillium Web', sans-serif" }}>
                    {stat?.value}
                  </div>
                  <div style={{ fontSize: '12px', color: '#888', lineHeight: '1.4' }}>{isFr ? stat.labelFr : stat.labelEs}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      {/* Project Image */}
      <section style={{ backgroundColor: '#111' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <img
            src="https://img.rocket.new/generatedImages/rocket_gen_img_138680f7d-1781029378321.png"
            alt="Infraestructura TI - redes y servidores empresariales implementados por Innobox"
            className="w-full"
            style={{ display: 'block', maxHeight: '480px', objectFit: 'cover' }} />
          
        </div>
      </section>
      {/* Project Overview */}
      <section style={{ paddingTop: '80px', paddingBottom: '80px', backgroundColor: '#fff' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            <div>
              <h2 className="font-bold text-black mb-6" style={{ fontSize: 'clamp(24px, 2.5vw, 36px)', fontFamily: "'Titillium Web', sans-serif" }}>
                Descripción del Proyecto
              </h2>
              <p style={{ fontSize: '16px', color: '#505050', lineHeight: '1.8', marginBottom: '20px' }}>
                Este proyecto consistió en el diseño, planificación e implementación completa de la infraestructura tecnológica 
                para una organización con múltiples sedes. El alcance incluyó la renovación total de la red corporativa, 
                virtualización de servidores y migración de servicios críticos a un entorno híbrido.
              </p>
              <p style={{ fontSize: '16px', color: '#505050', lineHeight: '1.8' }}>
                Trabajamos en estrecha colaboración con el equipo interno del cliente para garantizar una transición sin 
                interrupciones, manteniendo la continuidad operativa durante todo el proceso de modernización.
              </p>
            </div>
            <div>
              <h2 className="font-bold text-black mb-6" style={{ fontSize: 'clamp(24px, 2.5vw, 36px)', fontFamily: "'Titillium Web', sans-serif" }}>
                Alcance y Tecnologías
              </h2>
              <div className="space-y-3">
                {['Cisco Networking (switches, routers, firewalls)', 'VMware vSphere / ESXi', 'Microsoft Azure Hybrid', 'Veeam Backup & Replication', 'Zabbix Monitoring', 'Structured Cabling Cat6A']?.map((tech, i) =>
                <div key={i} className="flex items-center gap-3">
                    <span style={{ width: '8px', height: '8px', backgroundColor: '#1AEF0F', borderRadius: '50%', flexShrink: 0 }} />
                    <span style={{ fontSize: '15px', color: '#333' }}>{tech}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Challenge / Solution */}
      <section style={{ paddingTop: '80px', paddingBottom: '80px', backgroundColor: '#f5f5f5' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            <div className="p-10" style={{ backgroundColor: '#0a0a0a' }}>
              <div className="flex items-center gap-3 mb-6">
                <i className="fas fa-exclamation-triangle text-yellow-400 text-xl" />
                <h3 className="font-bold text-white" style={{ fontSize: '22px', fontFamily: "'Titillium Web', sans-serif" }}>
                  El Desafío
                </h3>
              </div>
              <p style={{ fontSize: '15px', color: '#aaa', lineHeight: '1.8', marginBottom: '16px' }}>
                La organización operaba con infraestructura obsoleta de más de 10 años, con frecuentes caídas de servicio, 
                cuellos de botella en la red y sin ninguna estrategia de respaldo ni recuperación ante desastres.
              </p>
              <p style={{ fontSize: '15px', color: '#aaa', lineHeight: '1.8' }}>
                La falta de segmentación de red exponía sistemas críticos a riesgos de seguridad, y el crecimiento 
                proyectado de la organización hacía insostenible continuar con la arquitectura existente.
              </p>
            </div>
            <div className="p-10" style={{ backgroundColor: '#1AEF0F' }}>
              <div className="flex items-center gap-3 mb-6">
                <i className="fas fa-check-circle text-black text-xl" />
                <h3 className="font-bold text-black" style={{ fontSize: '22px', fontFamily: "'Titillium Web', sans-serif" }}>
                  La Solución
                </h3>
              </div>
              <p style={{ fontSize: '15px', color: '#0a0a0a', lineHeight: '1.8', marginBottom: '16px' }}>
                Diseñamos una arquitectura de red segmentada con VLANs por departamento, implementamos un core de switches 
                Cisco con redundancia y desplegamos un entorno virtualizado con alta disponibilidad.
              </p>
              <p style={{ fontSize: '15px', color: '#0a0a0a', lineHeight: '1.8' }}>
                La solución incluyó políticas de backup automatizadas con retención de 30 días, monitoreo proactivo 24/7 
                y documentación técnica completa para el equipo interno del cliente.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Capabilities */}
      <section style={{ paddingTop: '80px', paddingBottom: '80px', backgroundColor: '#fff' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <div className="mb-12">
            <h2 className="font-bold text-black mb-3" style={{ fontSize: 'clamp(24px, 2.5vw, 36px)', fontFamily: "'Titillium Web', sans-serif" }}>
              Capacidades Aplicadas
            </h2>
            <p style={{ fontSize: '16px', color: '#505050', maxWidth: '600px', lineHeight: '1.6' }}>
              Competencias técnicas y metodológicas que hicieron posible este proyecto de infraestructura.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0">
            {capabilities?.map((cap, i) =>
            <div
              key={i}
              className="group p-8 transition-all duration-300 hover:bg-[#f9f9f9]"
              style={{ borderBottom: '1px solid #E2E2E2', borderRight: i % 3 !== 2 ? '1px solid #E2E2E2' : 'none' }}>
              
                <div className="mb-5 flex items-center justify-center" style={{ width: '52px', height: '52px', border: '1px solid #E2E2E2', borderRadius: '50%' }}>
                  <i className={`${cap?.icon} text-xl text-black group-hover:text-[#1AEF0F] transition-colors duration-300`} />
                </div>
                <h3 className="font-semibold text-black mb-3" style={{ fontSize: '17px', fontFamily: "'Titillium Web', sans-serif" }}>{cap?.title}</h3>
                <p style={{ fontSize: '14px', color: '#505050', lineHeight: '1.6' }}>{cap?.description}</p>
              </div>
            )}
          </div>
        </div>
      </section>
      {/* Sectors */}
      <section style={{ paddingTop: '60px', paddingBottom: '80px', backgroundColor: '#f5f5f5' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <h2 className="font-bold text-black mb-10" style={{ fontSize: 'clamp(22px, 2vw, 30px)', fontFamily: "'Titillium Web', sans-serif" }}>
            Sectores que Atendemos
          </h2>
          <div className="flex flex-wrap gap-4">
            {sectors?.map((s, i) =>
            <div key={i} className="flex items-center gap-3 px-6 py-4 bg-white" style={{ border: '1px solid #E2E2E2' }}>
                <i className={`${s?.icon} text-[#1AEF0F]`} />
                <span style={{ fontSize: '15px', fontWeight: '600', color: '#111' }}>{s?.label}</span>
              </div>
            )}
          </div>
        </div>
      </section>
      {/* CTA */}
      <section style={{ paddingTop: '70px', paddingBottom: '70px', backgroundColor: '#1AEF0F' }}>
        <div className="max-w-[1200px] mx-auto px-[35px] flex flex-col sm:flex-row items-center justify-between gap-6">
          <p className="text-black font-bold m-0" style={{ fontSize: 'clamp(18px, 2vw, 26px)', fontFamily: "'Titillium Web', sans-serif", lineHeight: '1.3' }}>
            ¿Necesitas modernizar tu infraestructura TI?
          </p>
          <Link href="/contact" className="group relative inline-flex items-center overflow-hidden border border-black text-black bg-transparent flex-shrink-0" style={{ padding: '14px 32px', fontSize: '15px', fontWeight: 'bold', transition: 'all 300ms ease-out' }}>
            <span className="relative z-10 transition-colors duration-300 group-hover:text-white">Contáctenos</span>
            <span className="absolute inset-0 bg-black transform translate-x-full group-hover:translate-x-0 transition-transform duration-300" style={{ zIndex: 0 }} />
          </Link>
        </div>
      </section>
      <Footer />
    </div>);

}